import { Experiment, User } from '@ms/yammer-data/dist/state/types';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';
import { useMtoEnabledAndAvailable } from '@ms/yammer-hooks/dist/multiTenantOrganization';
import { useViewerCanAccessUserStoryline } from '@ms/yammer-hooks/dist/userHeaders';
import { useCanCurrentUserAccessStoryline } from '@ms/yammer-hooks/dist/userProfile';
import { useFindUser, useIsExternal, useIsMtoHubUser } from '@ms/yammer-hooks/dist/users';

import { UseUIFeatureCheck } from '../types';

export { useCanCurrentUserAccessStorylineHome } from '@ms/yammer-hooks/dist/storylineHome';
export { useCanCurrentUserAccessStoryline };

// This hook is a copy of @ms/yammer-hooks/dist/userProfile -> useCanUserAccessStoryline.
// The key difference is it won't throw in case the user object cannot be found, allowing the hook to be called while user data is still being fetched.
export const useCanUserAccessStoryline: UseUIFeatureCheck<[userId: User['id']]> = (userId) => {
  const canViewerAccessUserStoryline = useViewerCanAccessUserStoryline(userId);
  const user = useFindUser(userId);
  const isMtoHubUser = useIsMtoHubUser(userId);
  const isMtoEnabled = useMtoEnabledAndAvailable();
  let isExternalUser = useIsExternal(userId);

  if (isMtoEnabled) {
    isExternalUser = isExternalUser && !isMtoHubUser;
  }

  if (!user) {
    return false;
  }

  return canViewerAccessUserStoryline && !user.isGuest && !isExternalUser;
};

export const useIsStorylineDraftPostEnabled: UseUIFeatureCheck = () => {
  const isStorylineDraftPostFeatureEnabled =
    useExperimentTreatmentWithoutReporting(Experiment.DraftPostStoryline) === true;

  return isStorylineDraftPostFeatureEnabled;
};
